import Typography from "@mui/material/Typography";
import { ReactNode } from "react";

export const Article = {
    Title: ({ anchor, children }: { anchor?: string, children: ReactNode }) => (
        <section id={anchor}>
        <Typography variant={"h3"}  gutterBottom>
            {children}
        </Typography>
        </section>
    ),
    SubTitle: ({ children}: { children: ReactNode}) => (
        <Typography variant={"h5"} gutterBottom>
            {children}
        </Typography>
    ),
    Body: ({ children, gap = true }: { children: ReactNode,  gap?: boolean }) => (
        <Typography variant="body1" gutterBottom={gap} paddingBottom={'32px'} style={{ textAlign: 'justify' }}>
            {children}
        </Typography>
    ),
};